import React from 'react';

import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';

import Download from '@src/components/common/Display/Download';

const ThumbnailMedia = ({ attachment, resourceType, resourceId }) => {
    const defaultThumbIcon = '/img/icons/download-document-icon.svg';
    let imgSource = attachment.thumbnail ? attachment.thumbnail.source : defaultThumbIcon;
    if (imgSource.indexOf('attachment-file-placeholder.png') > -1) {
        imgSource = defaultThumbIcon;
    }

    return (
        <Card className="thumbnail-media-card">
            {
                imgSource
                && (
                    <Card.Body className="pb-0">
                        <div className="media">
                            <img
                                src={imgSource}
                                alt={attachment.display_name}
                                className="thumbnail img-fluid"
                            />
                        </div>
                    </Card.Body>
                )
            }
            <Card.Footer>
                <h4>{attachment.display_name}</h4>
                <div className="media-body pt-4">
                    <div>
                        <Download
                            attachment={attachment}
                            resourceType={resourceType}
                            resourceId={resourceId}
                        >
                            Download
                        </Download>
                    </div>
                </div>
            </Card.Footer>
        </Card>

    );
};

ThumbnailMedia.propTypes = {
    attachment: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        filename: PropTypes.string.isRequired,
        thumbnail: PropTypes.shape({
            source: PropTypes.string.isRequired,
            alt: PropTypes.string,
        }),
         
        display_name: PropTypes.string,
    }).isRequired,
    resourceType: PropTypes.string,
    resourceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const Downloads = ({ attachments, resourceType, resourceId }) => {
    return (
        <div className="container-fluid p-0">
            <div className="row-full-width bg-color downloadable-resources">
                <div className="col text-center justify-content-center">
                    <h2>Downloadable Resources</h2>
                    <div className="row main-container-row pb-5">
                        {
                            attachments.map((a) => (
                                <div key={a.id} className="col-12 col-sm-3 mb-3">
                                    <ThumbnailMedia
                                        attachment={a}
                                        resourceType={resourceType}
                                        resourceId={resourceId}
                                    />
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

Downloads.propTypes = {
    attachments: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        filename: PropTypes.string.isRequired,

        thumbnail: PropTypes.shape({
            source: PropTypes.string.isRequired,
        }),
         
        display_name: PropTypes.string,
    })).isRequired,
    resourceType: PropTypes.string,
    resourceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
